/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSlash = createReactComponent("slash", "IconSlash", [
  ["path", { d: "M17 5l-10 14", key: "svg-0" }]
]);

export { IconSlash as default };
//# sourceMappingURL=IconSlash.js.map
